// assets
import { AiOutlineHome, AiOutlineEnvironment, AiOutlineTeam, AiOutlineTrophy, AiOutlineSetting, AiOutlineHighlight, AiOutlineNodeIndex, AiOutlineFlag, AiOutlineUser, AiOutlineBook, AiOutlineExclamationCircle, AiOutlineBgColors } from 'react-icons/ai';

// ==============================|| MENU ITEMS - PAGES ||============================== //
const getVenueAdminPage = (selectedVenue, selectedVenueData) => {
  if (!selectedVenue?.value) return null;

  const base = `/dashboard/venue/${selectedVenue.value}`;

  return { 
    id: 'group-venues',
    title: selectedVenue?.label,
    type: 'group',
    children: [
      {
        id: 'venue-dashboard',
        title: 'Dashboard',
        type: 'collapse',
        icon: AiOutlineHome,
        url: base,
        children: [
          {
            id: 'venue-band-holders',
            title: 'Band Holders',
            type: 'item',
            url: `${base}/band-holders`
          },
          ...(selectedVenueData?.singleUseBands === 1 || selectedVenueData?.singleUseBands === true ? [{
            id: 'venue-single-use-bands',
            title: 'Single Use Bands',
            type: 'item',
            url: `${base}/single-use-bands`
          }] : [])
        ]
      },
      {
        id: 'venue-dashboard-management',
        title: 'Venue Management',
        type: 'collapse',
        icon: AiOutlineHighlight,
        url: `${base}/manage`,
        children: [
          { id: 'venue-details', title: 'Details', type: 'item', icon: AiOutlineBook, url: `${base}/manage/details` },
          { id: 'venue-zones', title: 'Zones', type: 'item', icon: AiOutlineEnvironment, url: `${base}/manage/zones` },
          { id: 'venue-activities', title: 'Activities', type: 'item', icon: AiOutlineFlag, url: `${base}/manage/activities` },
          { id: 'venue-data', title: 'Data Points', type: 'item', icon: AiOutlineNodeIndex, url: `${base}/manage/datapoints` },
          { id: 'venue-staff', title: 'Staff', type: 'item', icon: AiOutlineTeam, url: `${base}/manage/staff` },
          { id: 'venue-milestones', title: 'Milestones', type: 'item', icon: AiOutlineTrophy, url: `${base}/manage/milestones` },
          { id: 'venue-guest-bands', title: 'Guest Bands', type: 'item', icon: AiOutlineUser, url: `${base}/manage/guest-bands` },
          { id: 'venue-incidents', title: 'Incidents', type: 'item', icon: AiOutlineExclamationCircle, url: `${base}/manage/incidents` },
          { id: 'venue-assets', title: 'Assets', type: 'item', icon: AiOutlineHighlight, url: `${base}${selectedVenue.value}/manage/assets` },
        ]
      },
      {
        id: 'venue-analytics-reports',
        title: 'Analytics & Reports',
        type: 'collapse',
        icon: AiOutlineNodeIndex,
        url: `${base}/analytics/attendance`,
        children: [
          { id: 'venue-dashboard-analytics-attendance', title: 'Attendance', type: 'item', url: `${base}/analytics/attendance` },
          { id: 'venue-dashboard-analytics-incidents', title: 'Incidents', type: 'item', url: `${base}/analytics/incidents` },
          { id: 'venue-dashboard-analytics-milestones', title: 'Milestones', type: 'item', url: `${base}/analytics/milestones` },
          { id: 'venue-dashboard-analytics-guestbands', title: 'Guest Bands', type: 'item', url: `${base}/analytics/guest-bands` },
        ]
      },
      {
        id: 'venue-bookings',
        title: 'Bookings',
        type: 'collapse',
        icon: AiOutlineBook,
        url: `${base}/bookings/calendar`,
        children: [
          { id: 'venue-bookings-calendar', title: 'Calendar', type: 'item', url: `${base}/bookings/calendar` },
          { id: 'venue-bookings-view', title: 'View All', type: 'item', url: `${base}/bookings/view` },
          { id: 'venue-bookings-bookable', title: 'Bookable Things', type: 'item', url: `${base}/bookables` },
          { id: 'venue-bookings-bookableactivities', title: 'Bookable Activities', type: 'item', url: `${base}/bookings/bookableactivities` },
          { id: 'venue-bookings-usertypes', title: 'User Types', type: 'item', url: `${base}/bookings/usertypes` },
          { id: 'venue-bookings-coupons', title: 'Promo Codes', type: 'item', url: `${base}/bookings/promocodes` },
        ]
      },
      {
        id: 'venue-memberships',
        title: 'Memberships',
        type: 'collapse',
        icon: AiOutlineTeam,
        url: `${base}/memberships/plans`,
        children: [
          { id: 'venue-memberships-plans', title: 'Plans', type: 'item', url: `${base}/memberships/plans` },
          { id: 'venue-memberships-view-all', title: 'View All', type: 'item', url: `${base}/memberships/participants` },
        ]
      },
      {
        id: 'venue-subscription',
        title: 'Subscription',
        type: 'item',
        icon: AiOutlineSetting,
        url: `${base}/settings/subscription`
      }
    ]
  };
};

export default getVenueAdminPage;